/* eslint-disable indent */
import React from "react";
import moment from "moment";
import "./styles.scss";

const RefreshTimestamp = ({ lastRefreshedAt, nextScheduledRefresh}) => {
    const formatLastRefresh = (date) => {
        if (!date) return "-";
        // Format for past events: no pipe separator
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
    };

    const formatNextSync = (date) => {
        if (!date) return "-";
        // Format for future events: with pipe separator
        if (typeof date === "string" && date.includes("|")) {
            return date;
        }
        return moment(date).format("YYYY-MM-DD | HH:mm:ss");
    };

    return (
        <div className="refresh-timestamp-container">
            <div className="timestamp-badge timestamp-badge-past">
                <span className="timestamp-label">Last Refresh</span>
                <span className="timestamp-value">
                    {formatLastRefresh(lastRefreshedAt)}
                </span>
            </div>
            <div className="timestamp-badge timestamp-badge-future">
                <span className="timestamp-label">Next Sync</span>
                <span className="timestamp-value">
                    {formatNextSync(nextScheduledRefresh)}
                </span>
            </div>
        </div>
    );
};

export default RefreshTimestamp;

